export const TAG_NAMES = {
  AI_ASSISTED_RUBRICS: 'AI assisted Rubrics',
}
